const typeLabels = {
  security: "Security Threat",
  fire: "Fire Emergency",
  medical: "Medical Emergency",
  accident: "Accident Report",
};

export function requestNotificationPermission() {
  if ("Notification" in window && Notification.permission === "default") {
    Notification.requestPermission();
  }
}

export function showBrowserNotification(alert) {
  if (!("Notification" in window) || Notification.permission !== "granted") return;

  const label = typeLabels[alert.alert_type] || "Emergency Alert";
  const body = alert.description || "New emergency reported near you";
  // Mirror the AlertCard rule: escalation_level >= 2 is the "CRITICAL" tier
  // (red pulsing badge). Critical notifications stay on screen until the
  // user acts; regular ones auto-close after 10s so they don't pile up.
  const isCritical = (alert.escalation_level || 0) >= 2;
  const title = isCritical
    ? `GUARD CRITICAL — ${label}`
    : `Guard: ${label}`;

  try {
    const notif = new Notification(title, {
      body,
      icon: "/favicon.ico",
      tag: alert.alert_id || "guard-alert",
      requireInteraction: true,
      silent: false,
    });

    notif.onclick = () => {
      window.focus();
      notif.close();
    };

    // Regular alerts auto-close after 10s; critical alerts stay until the
    // user clicks/dismisses them so they aren't lost when stacked on a
    // busy desktop.
    if (!isCritical) setTimeout(() => notif.close(), 10000);
  } catch (e) {
    // Notification API not supported or blocked
    console.debug("showBrowserNotification", e);
  }
}

/**
 * Doorbell-specific browser notification. Used when a visitor rings while
 * the resident has Guard open but the tab is unfocused — they'd otherwise
 * miss the in-app ring chime if their tab is muted or backgrounded.
 *
 * `requireInteraction: true` keeps the toast on screen until the user
 * dismisses it (or clicks it to focus Guard). The same `tag` per ring
 * de-duplicates: if the listener fires twice, only one OS notification
 * shows.
 */
export function showDoorbellNotification(ring, onClick) {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  try {
    const visitor = ring.visitor_name || "Visitor";
    const notif = new Notification("Guard Doorbell — someone's at the door", {
      body: `${visitor} is ringing. Click to answer.`,
      icon: "/favicon.ico",
      tag: ring.ring_id || "guard-doorbell",
      requireInteraction: true,
      silent: false,
    });
    notif.onclick = () => {
      window.focus();
      notif.close();
      onClick?.();
    };
    // 45s — same as the visitor-side no-answer timeout. After that the
    // ring is server-side ended anyway, so dismissing the notification
    // matches reality.
    setTimeout(() => notif.close(), 45000);
  } catch (e) {
    // Notification API not supported or blocked — chime + dialog still play.
    console.debug("showDoorbellNotification", e);
  }
}
